"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var commomCardHolderNames_1 = require("../utils/commomCardHolderNames");
var validateCardHolderName = function (value) {
    var sanitazedValue = value.toLowerCase()
        .replace(' ', '')
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    var isCommomCardHolderName = commomCardHolderNames_1.commomCardHolderNames
        .includes(sanitazedValue);
    if (isCommomCardHolderName) {
        return 'Nome do titular inválido! Digite o mesmo nome impresso no cartão';
    }
    return false;
};
exports.default = validateCardHolderName;
//# sourceMappingURL=cardHolderName.js.map